import { render, staticRenderFns } from "./OriginSite.vue?vue&type=template&id=7b835f7e&scoped=true&"
import script from "./OriginSite.vue?vue&type=script&lang=js&"
export * from "./OriginSite.vue?vue&type=script&lang=js&"
import style0 from "./OriginSite.vue?vue&type=style&index=0&id=7b835f7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b835f7e",
  null
  
)

export default component.exports